'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var forms = require('@reactables/forms');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var FormContext = React__default["default"].createContext(null);
var Form = function (_a) {
    var rxForm = _a.rxForm, children = _a.children;
    var state = rxForm[0];
    return React__default["default"].createElement(FormContext.Provider, { value: rxForm }, state && children);
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var Field = function (_a) {
    var Component = _a.component, _b = _a.name, name = _b === void 0 ? 'root' : _b, props = __rest(_a, ["component", "name"]);
    var _c = React.useContext(FormContext), state = _c[0], _d = _c[1], markControlAsTouched = _d.markControlAsTouched, updateValues = _d.updateValues;
    if (!state[name]) {
        throw "Control '".concat(name, "' can not be found");
    }
    var _e = state[name], controlRef = _e.controlRef, touched = _e.touched, value = _e.value;
    var inputProps = {
        name: name,
        value: value,
        onBlur: function () {
            if (!touched)
                markControlAsTouched({ controlRef: controlRef });
        },
        onChange: function (event) {
            var value;
            if (event.currentTarget) {
                switch (event.currentTarget.type) {
                    case 'checkbox':
                        value = event.currentTarget.checked;
                        break;
                    case 'email':
                    case 'text':
                    default:
                        value = event.currentTarget.value;
                }
            }
            else {
                value = event;
            }
            updateValues({
                controlRef: controlRef,
                value: value
            });
        }
    };
    return React__default["default"].createElement(Component, __assign({ input: inputProps, meta: state[name] }, props));
};

var FormArray = function (_a) {
    var _b = _a.name, name = _b === void 0 ? 'root' : _b, children = _a.children;
    var _c = React.useContext(FormContext), state = _c[0], _d = _c[1], pushControl = _d.pushControl, removeControl = _d.removeControl;
    var controlRef = state[name].controlRef;
    var items = forms.getArrayItems(controlRef, state);
    var formArrayChildrenProps = {
        items: items,
        pushControl: function (config) {
            pushControl({ controlRef: controlRef, config: config });
        },
        removeControl: function (index) { return removeControl(controlRef.concat(index)); }
    };
    return React__default["default"].createElement("div", null, children && children(formArrayChildrenProps));
};

exports.Field = Field;
exports.Form = Form;
exports.FormArray = FormArray;
Object.keys(forms).forEach(function (k) {
  if (k !== 'default' && !exports.hasOwnProperty(k)) Object.defineProperty(exports, k, {
    enumerable: true,
    get: function () { return forms[k]; }
  });
});
